import React from 'react';
import { string } from 'prop-types';
import './SurveyJob.scss';

class SurveyJob extends React.Component {
  static propTypes = {
    surveyCode: string,
    surveyJobCode: string,
    surveyJobDescription: string,
    surveyJobTitle: string
  };

  render() {
    const { surveyCode, surveyJobCode, surveyJobDescription, surveyJobTitle } = this.props;

    return (
      <div className="comp-sum-survey-jd">
        <div className="comp-sum-survey-jd__section">
          <div className="pricing-details__title">{surveyJobTitle}</div>
          <div className="pricing-details__subtitle">{surveyJobCode}</div>
        </div>
        <div className="comp-sum-survey__survey">{surveyCode}</div>
        <div className="comp-sum-survey-jd__description">{surveyJobDescription}</div>
      </div>
    );
  }
}

export default SurveyJob;
